/* tslint:disable */
/* eslint-disable */
/**
 * crm-phone-agent
 * crm-phone-agent
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InsuranceType } from './InsuranceType';
import {
    InsuranceTypeFromJSON,
    InsuranceTypeFromJSONTyped,
    InsuranceTypeToJSON,
    InsuranceTypeToJSONTyped,
} from './InsuranceType';

/**
 * 
 * @export
 * @interface TargetCompany
 */
export interface TargetCompany {
    /**
     * 
     */
    name: TargetCompanyNameEnum;
    /**
     * 
     */
    type: InsuranceType;
}


/**
 * @export
 */
export const TargetCompanyNameEnum = {
    Aetna: 'Aetna',
    BcbsMichigan: 'BCBS Michigan',
    AnthemBcbsElevanceHealth: 'Anthem BCBS (Elevance Health)',
    BlueCrossBlueShieldBcbs: 'Blue Cross Blue Shield (BCBS)',
    HcscBcbs: 'HCSC BCBS',
    HighmarkBcbs: 'Highmark BCBS',
    Cigna: 'Cigna',
    Humana: 'Humana',
    UnitedHealthcare: 'UnitedHealthcare',
} as const;
export type TargetCompanyNameEnum = typeof TargetCompanyNameEnum[keyof typeof TargetCompanyNameEnum];


/**
 * Check if a given object implements the TargetCompany interface.
 */
export function instanceOfTargetCompany(value: object): value is TargetCompany {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function TargetCompanyFromJSON(json: any): TargetCompany {
    return TargetCompanyFromJSONTyped(json, false);
}

export function TargetCompanyFromJSONTyped(json: any, ignoreDiscriminator: boolean): TargetCompany {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': InsuranceTypeFromJSON(json['type']),
    };
}

export function TargetCompanyToJSON(json: any): TargetCompany {
    return TargetCompanyToJSONTyped(json, false);
}

export function TargetCompanyToJSONTyped(value?: TargetCompany | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': InsuranceTypeToJSON(value['type']),
    };
}

